<template>
  <div>
<van-search v-model="searchText" placeholder="请输入搜索关键词" shape="round" @search="gosearch(searchText)" />

<van-swipe :autoplay="3000"  class="swiperadius" v-if="poster.length>0">
  <van-swipe-item v-for="(image, index) in poster" :key="index" >
	<a :href="image.url">
    <img v-lazy="image.image" width="100%" height="100%"/>
	</a>
  </van-swipe-item>
</van-swipe>
<div class="header-silder">
<ul class="silder-list">
  <li
	:id="'item' + index"
	v-for="(item, index) in cat_arr"
	@click="changeTab(index, item)"
	:class="{ current: currentIndex === index }"
	:key="index"
	:style="index ==cat_arr.length-1 ? {width:'6.25rem',textAlign:'left',paddingLeft:'0.5rem'} : ''"
  >{{ item.itemName }}</li>
</ul>
<div class="more" @click="shows"></div>
</div>

<!-- 有内容时候的页面 -->
<div class="wrapper" :style="{ 'min-height': maxHeight }" style="background-color: #efefef;padding-top:0.625rem;">
      <van-list
        v-model="isMyLoading"
        :finished="finished"
        finished-text="没有更多"
        @load="goodsList(searchText)"
        offset="500"
        :immediate-check="false"
        ref="list"
		style="padding-bottom: 4rem;"
      >
        <div
          class="goodsitem"
          v-for="(item, index) in form"
          :key="index"
          @click="detail(item)"
        >
		<div class="goodsitem_top">
		    <div class="imgcon">
			  <img :src="item.coverImage" width="100%"/>
		    </div>
			<div class="infoleft">
				<div class="title">{{item.name}}</div>
				<div class="infotag">授课形式：{{item.typeTags}}</div>
			</div>
		</div>
		<div class="goodsitem_middle" v-if="item.brief&&item.brief.length>0">
			<div v-for="(bitem,indexs) in item.brief" :key="indexs"  class="tagitem">{{bitem}}</div>
		</div>
		<div class="goodsitem_bottom">
			<div class="tryseebar" >
				<div v-if="item.trySeeCount>0" style="display: flex;align-items:center;line-height: 15px;margin-top: 2px;"><van-icon name="play-circle" style="padding-right:5px;" size="11" />支持免费试看</div>
			</div>
			<div class="price" v-if="(promote_check(item)&&item.discountPrice>0)||item.product.originalPrice>0">
							  <div v-if="promote_check(item)"><span class="trueprice">￥{{(item.product.discountPrice/100).toFixed(2)}}</span></div>
							  <div><span v-bind:class="[promote_check(item) ? 'delprice':'trueprice']">￥{{(item.product.originalPrice/100).toFixed(2)}}</span></div>
			</div>
			<div class="price_free" v-if="(promote_check(item)&&item.discountPrice==0)||item.product.originalPrice==0">
				<div>限时免费</div>	
			</div>
		</div>
        </div>
      </van-list>
	  <van-empty description="暂无数据" v-show="form.length == 0" />
	  <div class="apple_safe"></div>
  </div>

<!-- 弹出层 -->
<van-popup
  v-model="show"
  closeable
  close-icon-position="top-left"
  position="bottom"
  :style="{ height: '90%' }"
>
  <div class="popup">
	<p class="type">考试类型选择</p>
	<ul class="mores">
	  <li
		v-for="(item, index) in cat_arr"
		@click="changeClass(index, item)"
		:class="{ currentId: currentIndex === index }"
		:key="index"
	  >{{ item.itemName }}</li>
	</ul>
  </div>
</van-popup>
	<Tabbar></Tabbar>
  </div>
</template>

<script>
import Vue from 'vue';
import { Lazyload } from 'vant';
import {api_base,api_goods} from '@/common/Request.js';
import Tabbar from '@/components/tabbar.vue';

Vue.use(Lazyload);

  export default {
    data() {
      return {
        searchText: "",
		maxHeight: "calc(" + window.innerHeight + "px" + " - 138px)",
		isMyLoading: false,
        poster:'',
		pageNo: 1,
		pageSize: 4,
		finished: false,
		loading: false,
		total: "",
		has_next: true,
		cat_arr: [
		  {
		    cat_id: "",
		    cat_name: "",
		    sort_order: ""
		  }
		],
		currentIndex: 1,
		projectid: 1,
		show:false,
		form: [],
        active: 0,
		tabbaractive:0,
      };
    },
	components: {
	  Tabbar
	},
    mounted (){
		//this.$cookies.set("user_token",'BhC6H0BmmkDW8*pkn65oBPS2lyazbRjpNmTS0*hhGsI_');
		//this.$cookies.set("mobilephone",'135****7195');
		//this.$cookies.set("userId",'5100001');
    		this.getposter();
			this.getCatList();
			this.onRefresh();
    },
    methods: {
      getposter(){
      	console.log("poster");
      	api_base.poster().then(response => {this.poster = response.data;
      	    console.log(response.data);
      			for(let index in this.poster)
      			{
      				if(this.poster[index].poster_img!=''){
      				this.poster[index].poster_img="http://v.huazhi.cn/mobile/"+this.poster[index].poster_img;
      				}
      				else{
      					this.poster[index].poster_img="http://v.huazhi.cn/images/no_picture.gif";
      				}
      			}
      		})
      },
	  getCatList() {
	    var obj = { itemValue: "0", itemName: "全部"};
		api_goods.category().then(
	      res => {
	        // console.log(res)
	        this.cat_arr = res.data.examList;
	        //this.cat_arr.unshift(obj);
	      }
	    );
	  },
	  onRefresh() {
	    this.form = [];
	    // this.pageNo = 1;
	     this.has_next = true;
	    //this.goodsList(keywords);
		this.goodsList();
	  },
	  changeTab(index, item) {
	    // let delta = document.getElementById("item" + index).offsetLeft;
	    // document.querySelector(".silder-list").scrollTo(delta, 0);
	    this.currentIndex = index;
	    this.projectid = item.itemValue;
	    //this.onRefresh(this.searchText);
		this.onRefresh();
	  },
	  shows() {
	    this.show = true;
	  },
	  changeClass(index, item) {
	    this.show = false;
	    // console.log(index,item)
	    let delta = document.getElementById("item" + index).offsetLeft;
	    document.querySelector(".silder-list").scrollTo(delta, 0);
	    this.currentIndex = index;
	    this.projectid = item.itemValue;
	    //this.onRefresh(this.searchText);
		this.onRefresh();
	  },
	  goodsList(keywords){
		
		  let self = this;
		  self.isMyLoading = true;
		  if (self.has_next) {
		    if (!keywords) {
			  // const paramsdata = {
				 //  pageSize:self.pageSize,
				 //  pageNo:self.pageNo
			  // }
			  
			  const paramsdata ={
				  locationId:10002
			  };
			  
			  if(self.projectid>0){
				  paramsdata.examId=self.projectid;
			  }
			  api_goods.recommend_list(paramsdata).then(res => {
				  console.log(res);
		          const list = res.data;
				  list.forEach(item => {
					  if(item.coverImage==''){
						item.coverImage="/img/default.jpg";
					  }
					   if(item.brief != '' &&  item.brief != null) {
					            item.brief = (item.brief).split(',')
						}
				  });
		          //self.total = parseInt(res.data.total);
		          // self.form = [...self.form, ...list];
				  self.form=list;
		          self.isMyLoading = false;
				  self.has_next = false;
		          // console.log('22',self.form );
		          // if ((self.pageNo) * self.pageSize < self.total) {
		          //   self.has_next = true;
		          // } else {
		          //   self.has_next = false;
		          // }
		          //self.pageNo++;
		        });
		    }
		  } else {
		    self.isMyLoading = false;
		  }  
	  },
	  detail(item) {
	    this.$router.push({
	      path: "goods_detail",
	      query: { goodsid: item.courseId }
	    });
	  },
	  promote_check(goodsinfo){
	  	if(goodsinfo.product.hasOwnProperty("discountPrice")){
	  		console.log(goodsinfo.product.discountPrice)
	  		if(goodsinfo.product.discountStartTime<new Date().getTime() && goodsinfo.product.discountEndTime>new Date().getTime()){
				return true;
	  		}
	  	}
		return false;
	  },
      gotoplay(){
        this.$router.push({ name: 'goods_detail', query: { goodsid: this.current_goods }});
      },
	  gosearch(searchText){
		this.$router.push({ name: 'course_search', query: { searchText: searchText }});
	  }
    },

  };
</script>

<style lang="scss" scoped>

  .swiperadius{
    margin-left:0.625rem;
    margin-right:0.625rem;
    border-radius:0.625rem;
    height:9.9375rem;
	
  }

  .van-list{
  }

 ::v-deep .van-list__placeholder{
	width:100% !important;
   }
  
  .goodsitem{
    padding: 0.9375rem;
	background-color: white;
	margin-bottom: 0.625rem;
	margin-left: 0.625rem;
	margin-right: 0.625rem;
	border-radius: 0.3125rem;
	
	.goodsitem_top{
		display: flex;
		padding-bottom: 0.625rem;
		.avator{
		  width: 2.6875rem;
		  height: 2.6875rem;
		  margin-left: 0.3125rem;
		}
		
		.infoleft{
			flex:0 60%;
			align-self: stretch;
			display: flex;
			flex-direction:column;
			.title{
				// flex:0 0 calc(100% - 24px);
				font-weight: bold;
				display:-webkit-box;
				overflow:hidden;
				text-overflow:ellipsis;
				-webkit-line-clamp:2;
				-webkit-box-orient:vertical;
				font-size:14px;
				color:#333;
			}
		}
		
		.infotag{
			flex:0 0 25%;
			font-size: 11px;
			color:#999;
			line-height: 19px;
			padding-top:5px;
			padding-bottom:5px;
			span{
				display: inline-block;
			}
		}
	}
	
	.goodsitem_bottom{
		border-top: solid 1px #eeeeee;
		padding-top: 0.625rem;
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		.price{
			flex:0 0 50%;
			width: 50%;
			color:#999;
			display: flex;
			flex-direction: row;
			justify-content: flex-end;
			flex-wrap: nowrap;
		}
		.tryseebar{
			flex:0 0 50%;
			width: 50%;
			color:#f33333;
			font-size: 11px;
		}
			
		.delprice{
		  text-decoration: line-through;
		  font-size: 0.6rem;
		  padding-left: 10px;
		}
		.price_free{
			color:#08BE67;
		}
	}
	


  }

  .imgcon > img{
    border-radius: 0.3125rem;
	height: 4.75rem;
  }


  .van-list > :nth-child(even){
    align-items: flex-end;
  }
  
  .van-list__placeholder{
	  width: 100%;
  }

  .goodstoolbar{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding-left: 0.625rem;
    padding-right: 0.625rem;
  }

  .teacher{
    flex: 0 0 40%;
    font-size: 0.8rem;
    color:#999;
  }


  

  .trueprice{
    color:#f33333;
	font-size: 14px;
  }
  
  
  .header-silder {
    /*position: fixed;*/
    top: 0.625rem;
	margin-bottom: 0.625rem;
    height: 2.75rem /* 44/16 */;
    width: 100%;
    background: #fff;
    /*border-bottom: 0.01rem solid #eee;*/
    z-index: 1;
	position: relative;
  }
  .silder-list {
    line-height: 2.75rem;
    height: 2.75rem /* 44/16 */;
    padding: 0.1rem 0.1rem;
    text-align: center;
    box-sizing: border-box;
    overflow-x: scroll;
    list-style: none;
    /*border-top: 0.01rem solid #eee;*/
    display: -webkit-box;
    overflow-y: hidden;
  }
  /*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/
  .silder-list::-webkit-scrollbar {
    display: none;
  }
  
  /*定义滚动条轨道 内阴影+圆角*/
  .silder-list::-webkit-scrollbar-track {
    display: none;
  }
  
  /*定义滑块 内阴影+圆角*/
  .silder-list::-webkit-scrollbar-thumb {
    display: none;
  }
  .silder-list li {
    font-size: 0.75rem /* 12/16 */;
    /* color: #595757; */
    color: #333333;
    width: 5.2rem;
    /* font-size: 0.34rem; */
    padding: 0rem 0.24rem;
    /* color: #505050bf; */
  }
  .more {
    width: 2.375rem /* 38/16 */;
    height: 2.75rem /* 44/16 */;
    background-color: red;
    /*float: right;*/
    position: absolute;
    top:0;
	right:0;
    background: url("/img/more.png") no-repeat;
    background-size: 100% 100%;
  }
  
  .popup {
    padding-top: 4.375rem /* 70/16 */;
    padding-left: 0.9375rem /* 15/16 */;
    padding-right: 0.9375rem /* 15/16 */;
  }
  .type {
    font-size: 0.875rem /* 14/16 */;
    color: #333333;
  }
  .popup .mores {
    margin-top: 1.3125rem /* 21/16 */;
  }
  .popup .mores li {
    width: 6.25rem /* 100/16 */;
    height: 1.875rem /* 30/16 */;
    border: 0.0625rem solid #cccccc;
    display: inline-block;
    text-align: center;
    line-height: 1.875rem /* 30/16 */;
    border-radius: 0.1875rem /* 3/16 */;
    margin-bottom: 1.25rem /* 20/16 */;
    margin-right: 0.92rem /* 21/16 */;
    font-size: 0.75rem /* 12/16 */;
  }
  .popup .mores li:nth-child(3n) {
    margin-right: 0;
  }
  .apple_safe{

  	  padding-bottom:constant(safe-area-inset-bottom);
  	  padding-bottom:env(safe-area-inset-bottom);
  }
  .current{
	  border-bottom: solid 2px #F33333;
  }
  
  .imgcon{
  	border-radius: 6px 6px 0 0;
  	position: relative;
	flex:0 calc(40% - 20px);
	margin-right: 20px;
  }
  
  .shikan{
  	position: absolute;
  	top:4px;
  	right:4px;
  	width: 40px;
  	height: 20px;
  	padding:5px;
  	background-color: #ff3530;
  	color:white;
  	text-align: center;
  	font-size:12px;
  	line-height: 12px;
  	border-radius: 3px;
  	font-weight: bold;
  	// box-shadow: 0 0 1px 0.5px rgba(0,0,0,0.3);
  }
  
  .goodsitem_middle{
    font-size:12px;
    display: flex;
    flex-direction: row;
    padding:0 0 10px 0;
  }
  
  .tagitem{
    flex:0 auto;
    text-align: center;
    background: #fff3f3;
    border-radius: 2px;
    margin-right: 0.625rem;
    color:#FF5249;
    padding:0.1875rem 0.625rem;
  }
  
</style>
